<div class="notification-popup">
  <div class="popup-content" [ngClass]="'size-' + size">
    <div class="popup-header" *ngIf="showHeader">
      <h3>{{ headerTitle }}</h3>
      <button class="close-btn" (click)="onClose()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
    <div class="popup-body">
      <div class="message" *ngIf="!showTable">{{ message }}</div>
      <div class="notifications-list" *ngIf="showTable">
        <div class="notification-item" *ngFor="let notification of tableData">
          <div class="notification-title">{{ notification['title'] }}</div>
          <div class="notification-message">{{ notification['message'] }}</div>
          <div class="notification-meta">
            <span class="notification-date">{{ notification['date'] }}</span>
            <span class="notification-status" [class.unread]="notification['status'] === 'Unread'">{{
              notification['status'] }}</span>
          </div>
        </div>
        <div class="notification-item" *ngIf="tableData.length === 0">
          <div class="no-data-box">
            <div class="no-record-desc">There are no Notifications available at this moment.</div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup-footer" *ngIf="showFooter">
      <button *ngFor="let button of footerButtons" class="btn {{ button.class }}" (click)="onAction(button.action)">
        {{ button.label }}
      </button>
    </div>
  </div>
</div>